import { useIntl } from 'react-intl';
import {
  DictionaryEvidence,
  TableCells,
  TableColumn,
  TableFieldColumn,
  TableFilterCells,
} from '@eas/common-web';
import { DataSource } from '@models';
import { useLanguages } from 'src/list-source/languages';
import { DataSourceFieldConfig } from 'src/models/data-source';

export function useColumns(): TableColumn<DataSource>[] {
  const intl = useIntl();
  const { dictionaryColumns } =
    DictionaryEvidence.useDictionaryColumns<DataSource>();

  return [
    {
      datakey: 'owner',
      name: intl.formatMessage({
        id: 'TAPIS__DATA_SOURCE__COLUMN__OWNER',
        defaultMessage: 'Majitel',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'area',
      name: intl.formatMessage({
        id: 'TAPIS__DATA_SOURCE__COLUMN__AREA',
        defaultMessage: 'Oblast',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'documentUrlMask',
      name: intl.formatMessage({
        id: 'TAPIS__DATA_SOURCE__COLUMN__DOCUMENT_URL_MASK',
        defaultMessage: 'maskaUrl',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
    },
    {
      datakey: 'language',
      filterkey: 'language.id',
      sortkey: 'language.name',
      name: intl.formatMessage({
        id: 'TAPIS__DATA_SOURCE__COLUMN__LANGUAGE',
        defaultMessage: 'Jazyk',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      FilterComponent:
        TableFilterCells.useFilterSelectCellFactory(useLanguages),
      valueMapper: TableCells.useSelectCellFactory(useLanguages),
    },

    ...dictionaryColumns,
  ];
}

export function useDataSourceConfigColumns(): TableFieldColumn<DataSourceFieldConfig>[] {
  const intl = useIntl();

  return [
    {
      datakey: 'key',
      name: intl.formatMessage({
        id: 'TAPIS__DATA_SOURECE__TABLE_COLUMN__KEY',
        defaultMessage: 'Atribut',
      }),
      width: 200,
    },
    {
      datakey: 'label',
      name: intl.formatMessage({
        id: 'TAPIS__DATA_SOURECE__TABLE_COLUMN__LABEL',
        defaultMessage: 'Popis',
      }),
      width: 200,
    },
  ];
}
